<template>
  <main>
    <b-card border-variant="light">
      <div class="card-text">
        <div class="d-flex flex-row justify-content-between line-height-golden">
          <span class="h6 font-weight-bold text-dark">Kundehenvendelser</span>
        </div>
        <span class="d-block mt-4">
          <b-btn variant="info" @click="kundeShow = !kundeShow" class="rounded">Se kort</b-btn>
        </span>
        <!-- Modal Component -->
        <b-modal lazy centered id="modal-center" ref="kundeModal" lazy v-model="kundeShow" title="Kundehenvendelser" size="lg">
          <!-- modalHeader -->
          <div slot="modal-header">
            <div class="d-flex flex-row justify-content-between py-2">
              <p class="h5 font-weight-bold pt-2 open-sans text-dark">Kort over kundehenvendelser</p>
              <b-btn variant="outline-dark" @click="closeKundeModal" class="border-0"><span><i class="el-icon-close"></i></span></b-btn>
            </div>
            <div class="h6 pt-2 open-sans line-height-golden">Her kan du se en oversigt over de henvendelser fra potentielle kunder, som vi endnu ikke har haft mulighed for at kontakte. Klik på en af markørerne for at læse om opgaven.</div>
          </div>
          <!-- component -->
          <b-container fluid>
            <b-row>
              <b-col class="py-3">
                <kundekort></kundekort>
              </b-col>
            </b-row>
          </b-container>
          <!-- modalFooter -->
          <div slot="modal-footer">
            <b-row class="pt-0 pr-2 pb-4 pl-2">
              <b-col>
                <b-btn type="reset" slot="modal-cancel" variant="outline-info" size="lg" @click="closeKundeModal" class="rounded">Luk</b-btn>
              </b-col>
            </b-row>
          </div>
        </b-modal>
      </div>
    </b-card>
  </main>
</template>
<script>
import kundekort from './../KundeMap'
export default {
  name: 'kundemodal',
  components: {
    kundekort
  },
  data () {
    return {
      kundeShow: false,
      form: {
        text: ''
      }
    }
  },
  methods: {
    closeKundeModal () {
      this.$refs.kundeModal.hide()
    }
  }
}
</script>


// WEBPACK FOOTER //
// KundeModal.vue?c67ecde6